function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import { Component, register } from 'ovee.js';
var PhoneInput = (_dec = register('phone-input'), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PhoneInput, _Component);

  var _super = _createSuper(PhoneInput);

  function PhoneInput() {
    _classCallCheck(this, PhoneInput);

    return _super.apply(this, arguments);
  }

  _createClass(PhoneInput, [{
    key: "init",
    value: function init() {
      var parentEl = this.$element.parentElement;
      this.phoneHiddenInput = parentEl.querySelector('input[name="phone_number"]'); // this.countryHiddenInput = parentEl.querySelector('input[name="country"]');

      this.input = intlTelInput(this.$element, {
        initialCountry: 'gb',
        separateDialCode: true,
        useFullscreenPopup: false,
        showFlags: false
      });
      this.$on('countrychange', this.onCountryChange.bind(this));
      this.$on('change', this.onHandleChange.bind(this));
      this.$on('keyup', this.onHandleChange.bind(this));
      this.$on('resize', window, this.updatePadding.bind(this));
      this.updatePadding();
    }
  }, {
    key: "onHandleChange",
    value: function onHandleChange() {
      if (this.phoneHiddenInput) {
        this.phoneHiddenInput.value = this.input.getNumber();
      }

      this.setCountry();
    }
  }, {
    key: "onCountryChange",
    value: function onCountryChange() {
      this.setCountry();
      this.updatePadding();
    }
  }, {
    key: "setCountry",
    value: function setCountry() {// const countryData = this.input.getSelectedCountryData();
      // if (this.countryHiddenInput) {
      // 	this.countryHiddenInput.value = countryData.name ?? '-';
      // }
    }
  }, {
    key: "updatePadding",
    value: function updatePadding() {
      var _this$input$countryCo, _this$input$countryCo2;

      var label = this.$element.closest('.base-form__label, label');

      if (!label) {
        return;
      }

      var padding = ((_this$input$countryCo = (_this$input$countryCo2 = this.input.countryContainer) === null || _this$input$countryCo2 === void 0 ? void 0 : _this$input$countryCo2.offsetWidth) !== null && _this$input$countryCo !== void 0 ? _this$input$countryCo : parseInt(this.$element.style.paddingLeft, 10)) + 5;
      label.style.setProperty('--input-padding-left', "".concat(padding, "px"));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.input) {
        this.input.destroy();
      }

      _get(_getPrototypeOf(PhoneInput.prototype), "destroy", this).call(this);
    }
  }]);

  return PhoneInput;
}(Component)) || _class);
export { PhoneInput as default };